<template>
    <ul ref="container" @scroll="setScrollStatus()">
      <li v-for="message in messages" :key="message.id">
        <chat-message-component :message="message.message" :type="message.type" :user="message.user" :date="message.date" />
      </li>
    </ul>
</template>

<script>
import ChatMessageComponent from '@/components/ChatMessage'

export default {
  components: {
    ChatMessageComponent
  },
  props: {
    messages: {
      type: Array,
      required: true
    },
    scroll: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    userScrolled: false
  }),
  watch: {
    messages () {
      this.scrollToLastMessage()
    },
    scroll () {
      this.userScrolled = false
    }
  },
  mounted () {},
  methods: {
    setScrollStatus () {
      this.userScrolled = this.$refs.container.scrollHeight > (this.$refs.container.clientHeight + this.$refs.container.scrollTop)
    },
    scrollToLastMessage () {
      if (this.userScrolled) {
        return
      }

      this.$nextTick(() => {
        let lastChildClientHeight = this.$refs.container.lastChild ? this.$refs.container.lastChild.clientHeight : 0
        this.$refs.container.scrollTop = this.$refs.container.scrollHeight - lastChildClientHeight
      })
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;

  padding-right: .2rem;

  min-height: 20rem;
  max-height: 30rem;

  overflow: hidden;
  overflow-y: auto;

  li:not(:last-child) {
    margin-bottom: .8rem;
    padding-bottom: .5rem;
    border-bottom: 1px dashed rgb(220,220,220);
  }
}

</style>
